// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"826d5f47","987":"b02931b0"}[chunkId] + ".chunk.js";
};